import Header from "@/components/Header";
import basicPlanPhoto from "@/assets/basicPlan.webp";
import proPlanPhoto from "@/assets/proPlan.webp";
import premiumPlanPhoto from "@/assets/premium.webp";
import { useEffect, useState } from "react";

import useBreadCrumb from "@/context/BreadCrumbContext";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "@/components/toast";
import api from "@/components/customAxios/Axios"
import { useNavigate } from "react-router-dom";
type PlanName = "Free-Trial" | "Silver" | "Golden" | "Platinum";

interface Plan {
	id: string;
	name: PlanName;
	amount: number;
	users_count: number;
	cv_count: number;
	assessment_count: number;
	duration_days: number;
	total_amount: number;
	gst_amount: number
}
const SelectPlan = () => {
	const { setLoading } = useLoader()
	const toast = useToast()
	const navigate = useNavigate()
	const { setBreadCrumb } = useBreadCrumb();
	const [isPlanMonthly, setIsPlanMonthly] = useState(true);
	const planImages: Record<Exclude<PlanName, "Free-Trial">, string> = {
		Silver: basicPlanPhoto,
		Golden: proPlanPhoto,
		Platinum: premiumPlanPhoto,
	};

	const planBestFor: Record<PlanName, string> = {
		"Free-Trial": "For First-Time Users",
		Silver: "For Small Business Owners",
		Golden: "For Mid-Sized Companies",
		Platinum: "For Large Enterprises",
	};

	const [plans, setPlans] = useState([
		{
			id: "434",
			label: "Basic Plan",
			image: basicPlanPhoto,
			amount: 60,
			bestFor: "For Small Business Owners",
			total_amount: 0,
			gst_amount: 0,
			point: [
				"Up to 5 users",
				"200 Resumes Screening",
				"50 Customizable Assessments",
				"AI Resume Scoring",
			],
		},
		{
			id: "3244",
			label: "Pro Plan",
			image: proPlanPhoto,
			amount: 150,
			total_amount: 0,
			gst_amount: 0,
			bestFor: "For Mid-Sized Companies",
			point: [
				"Up to 10 users",
				"500 Resumes Screening",
				"100 Customizable Assessments",
				"AI Resume Scoring",
			],
		},
		{
			id: "4564",
			label: "Premium Plan",
			image: premiumPlanPhoto,
			amount: 300,
			total_amount: 0,
			gst_amount: 0,
			bestFor: "For Large Enterprises",
			point: [
				"Up to 30 users",
				"700 Resumes Screening",
				"200 Customizable Assessments",
				"AI Resume Scoring",
			],
		},
	]);
	const getPlanDetails = async () => {
		try {
			setLoading(true);
			const response = await api.get("/subscription_plans");
			if (response.status === 200) {
				const transformed = response.data.map((plan: Plan) => ({
					id: plan.id,
					label: plan.name,
					image: planImages[plan.name as keyof typeof planImages] || basicPlanPhoto,
					amount: plan.amount,
					bestFor: planBestFor[plan.name] || "Flexible Plan",
					point: [
						`Up to ${plan.users_count} users`,
						`${plan.cv_count} Resumes Screening`,
						`${plan.assessment_count} Customizable Assessments`,
						`${plan.duration_days} Days Access`,
					],
					total_amount: plan.total_amount,
					gst_amount: plan.gst_amount
				}));

				setPlans(transformed);
				// setUserData({
				// 	firstName: response.data.first_name,
				// 	lastName: response.data.last_name,
				// 	email: response.data.email,
				// 	phoneNumber: response.data.phone_number,
				// })
				// setUserName(userData.firstName);
			}
		} catch (error: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error updating profile",
				description: error.response?.data?.message || error.response?.data?.error || "An error occurred, please try again later.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getPlanDetails()
	}, [])
	const nextPage = (planName: string, planID: string) => {
		localStorage.setItem("plan", planName);
		localStorage.setItem("planId", planID);
		navigate("/billing-details");
	};


	useEffect(() => {
		setIsPlanMonthly(true)
		setBreadCrumb({
			mainLabel: {
				label: "Settings",
				link: "/settings",
			},
			currentLabel: "Select Plan",
		});
		localStorage.setItem("currentTab", "Subscription Management");
	}, []);

	return (
		<>
			<div className="min-h-[90vh]">
				<Header />

				<div className="flex justify-center ">
					<div className="w-[563px] text-center space-y-5">
						<h1 className="text-4xl font-semibold text-center mt-3">
							Choose the Perfect Plan for your Hiring Needs
						</h1>
						<p>
							Choose from our flexible plans tailored to meet the unique hiring needs of businesses of all sizes-from startups to large enterprises.
						</p>

						{/* <label className="inline-flex items-center cursor-pointer">
							<span className="me-3 text-sm font-medium text-gray-900 dark:text-gray-300">
								Monthly
							</span>
							<input
								onChange={() => setIsPlanMonthly((prev) => !prev)}
								type="checkbox"
								value=""
								className="sr-only peer"
							/>
							<div className="relative w-11 h-6 bg-white border   rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-[#9AB9B1] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-white dark:peer-checked:bg-blue-600"></div>
							<span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
								Yearly
							</span>
							<span className="mx-2 font-light text-[#568176]">-20% off</span>
						</label> */}
					</div>
				</div>
				<div className="flex justify-center items-center  gap-5 mt-5 mb-5 flex-wrap">
					{plans.map((elem) => (
						<div
							className="w-[300px] rounded-2xl overflow-hidden shadow-md p-6 bg-white flex flex-col items-center"
							key={elem.id}
						>
							{/* Image */}
							<div className="w-full h-40 rounded-xl overflow-hidden relative mb-6">
								<img
									src={elem.image}
									alt="Basic Plan"
									className="object-cover w-full h-full"
								/>
								<div className="absolute inset-0 flex items-center justify-center ">
									<h2 className="text-white text-2xl font-semibold drop-shadow-xl">
										{elem.label}
									</h2>
								</div>
							</div>

							{/* Price */}
							<div className="flex items-end mb-2">
								<span className="text-3xl font-bold">
									${isPlanMonthly ? elem.amount : elem.amount * 10}
								</span>
								<span className="text-gray-500 text-lg font-semibold ml-1 mb-1">
									/{isPlanMonthly ? "month" : "year"}
								</span>
							</div>

							{/* Subtext */}
							<div className="text-gray-500  my-4 text-xs text-center border rounded-3xl px-5 py-2">
								{elem.bestFor}
							</div>

							{/* Whats included */}
							<div className="w-full mb-6">
								<h3 className="font-semibold text-base  mb-3 text-center">
									What’s Included
								</h3>
								<ul className="space-y-3 text-gray-700 text-left text-sm">
									{elem.point.map((elem, index) => (
										<li className="flex items-center gap-2" key={index}>
											<span className="text-green-500">✓</span> {elem}
										</li>
									))}
								</ul>
							</div>

							{/* Button */}
							<div className="w-full">
								<button
									onClick={() => nextPage(elem.label, elem.id)}
									className={`
                    hover:bg-[#245045] hover:text-white
                    bg-[#F4F4F4] text-[#4A7D70]
            w-full py-2 rounded-full  font-semibold  transition-all`}
								> Choose Plan</button>
								{/* <PaymentDetailsModal baseAmount={elem.amount.toString()} gstAmount={elem.gst_amount.toString()} totalAmount={elem.total_amount.toString()} planID={elem.id} planName={elem.label} /> */}
							</div>

						</div>
					))}
				</div>
			</div>
			<footer className="bg-[#263238] h-[10vh] "></footer>
		</>
	);
};

export default SelectPlan;
